import React from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Stack } from '@atlaskit/primitives';
import {
	AgentConversationStarters,
	type AgentConversationStartersProps,
	type ConversationStarter,
} from '@atlaskit/rovo-agent-components';

import { MainContentHeaders } from './utils';

export const AgentConversationStartersSection = ({
	isAgentDefault,
	onConversationStarterClick,
	userDefinedConversationStarters,
}: AgentConversationStartersProps) => {
	const { formatMessage } = useIntl();

	const handleConversationStarterClick = (conversationStarter: ConversationStarter) => {
		onConversationStarterClick(conversationStarter);
	};
	return (
		<Stack space="space.200">
			<MainContentHeaders>{formatMessage(messages.openChatLabel)}</MainContentHeaders>
			<Stack alignInline="start" space="space.100">
				<AgentConversationStarters
					isAgentDefault={isAgentDefault}
					onConversationStarterClick={handleConversationStarterClick}
					userDefinedConversationStarters={userDefinedConversationStarters}
				/>
			</Stack>
		</Stack>
	);
};

const messages = defineMessages({
	openChatLabel: {
		id: 'ptc-directory.agent-profile.conversation-starter.header',
		defaultMessage: 'Open chat',
		description: 'Label for about section of the agent',
	},
});
